import PerformanceGraph from "components/PerformanceGraph/PerformanceGraph";
import React from "react";
import QuoteInfo from "../Quote/QuoteInfo";
import styles from "./StockPerformance.module.scss";
import { IexQuote } from "$gql/types.gen";
import { AdCampaign } from "components/AdCampaign/AdCampaign";
import { useQueryBundle } from "source/hooks";
import { GetWiim24Hours } from "$gql/queries/general/GetWIIM24Hours.gen";
import WIIM from "../WhyIsItMoving/WIIM";
import { Media } from "components/Media/media";
import classNames from "classnames";

type Props = {
  tickerSymbol: string;
  quote?: IexQuote | null;
  showSidebarAd?: boolean;
  openTradeModal(): void;
};

const StockPerformance = (props: Props) => {
  const wiim = useQueryBundle(GetWiim24Hours, {
    variables: {
      tickers: [props.tickerSymbol],
    },
  });

  return (
    <div className={styles.outerContainer}>
      <div className="container">
        <h2>Stock Performance</h2>
        <div className={styles.container}>
          <div className={styles.chartContainer}>
            <PerformanceGraph tickerSymbol={props.tickerSymbol} />
            <Media lessThan="lg">
              <div className={styles.priceBox}>
                <div className={styles.priceInfo}>
                  {props.quote ? (
                    <QuoteInfo
                      quote={props.quote}
                      button
                      inline
                      large
                      openTrade={props.openTradeModal}
                    />
                  ) : (
                    <h5>Loading...</h5>
                  )}
                </div>
                <Media greaterThanOrEqual="lg">
                  <div className={styles.adSection}>
                    {props.showSidebarAd && (
                      <div className={styles.sideAdWrapper}>
                        <AdCampaign
                          size="md-rectangle"
                          keywords={[props.tickerSymbol]}
                        />
                      </div>
                    )}
                  </div>
                </Media>
              </div>
            </Media>
            {wiim.state === "DONE" &&
              wiim.data.getWIIM24Hours.length > 0 &&
              props.showSidebarAd && (
                <WIIM
                  headline={wiim.data.getWIIM24Hours[0].headline}
                  earlyLineBreak={props.showSidebarAd}
                />
              )}
          </div>
          <Media greaterThanOrEqual="lg">
            {" "}
            <div className={styles.priceBox}>
              <div className={styles.priceInfo}>
                {props.quote ? (
                  <QuoteInfo
                    quote={props.quote}
                    button
                    inline
                    large
                    openTrade={props.openTradeModal}
                  />
                ) : (
                  <h5>Loading...</h5>
                )}
              </div>
              <Media greaterThanOrEqual="lg">
                <div className={styles.adSection}>
                  {props.showSidebarAd && (
                    <div className={styles.sideAdWrapper}>
                      <AdCampaign
                        size="md-rectangle"
                        keywords={[props.tickerSymbol]}
                      />
                    </div>
                  )}
                </div>
              </Media>
            </div>
          </Media>
        </div>
        {!props.showSidebarAd &&
          wiim.state === "DONE" &&
          wiim.data.getWIIM24Hours.length > 0 && (
            <WIIM
              headline={wiim.data.getWIIM24Hours[0].headline}
              earlyLineBreak={props.showSidebarAd}
            />
          )}
        <Media lessThan="lg">
          <div
            className={classNames(
              styles.adSection,
              styles.adSection_MobileBottom
            )}
          >
            {props.showSidebarAd && (
              <div className={styles.sideAdWrapper}>
                <AdCampaign
                  size="md-rectangle"
                  keywords={[props.tickerSymbol]}
                />
              </div>
            )}
          </div>
        </Media>
      </div>
    </div>
  );
};

export default StockPerformance;
